var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      ref: _vm.dialogRef,
      attrs: { id: "general-form-wrapper", "md-click-outside-to-close": true }
    },
    [
      _c("md-dialog-content"),
      _c(
        "loader",
        { attrs: { loading: _vm.loading, size: 45 } },
        [
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary md-raised button",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v("X")]
              )
            ],
            1
          ),
          _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.seriesName))]),
          _vm.associatedData.length > 0
            ? _c(
                "md-dialog-title",
                { staticClass: "md-headline" },
                _vm._l(_vm.associatedData, function(season, idxSeason) {
                  return _c(
                    "div",
                    { staticClass: "info" },
                    [
                      season.seasonNumber
                        ? _c(
                            "h3",
                            {
                              staticClass: "season",
                              on: {
                                click: function($event) {
                                  return _vm.changeShowItem(idxSeason)
                                }
                              }
                            },
                            [_vm._v("Season " + _vm._s(season.seasonNumber))]
                          )
                        : _vm._e(),
                      _vm._l(season.videos, function(video) {
                        return _c("div", [
                          _vm.showItem && idxSeason === _vm.indexSeason
                            ? _c(
                                "a",
                                {
                                  staticClass: "videos info",
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "video/" + video.id
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(video.episodeNumber) +
                                      " - " +
                                      _vm._s(video.name)
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      }),
                      _vm._l(season.videos, function(video) {
                        return !season.seasonNumber
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "videos info",
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "video/" + video.id
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(video.episodeNumber) +
                                      " - " +
                                      _vm._s(video.name)
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                }),
                0
              )
            : _c("md-layout", { attrs: { "md-align": "center" } }, [
                _c(
                  "span",
                  { attrs: { id: "no-results" } },
                  [
                    _c("md-icon", {
                      staticClass: "md-accent",
                      attrs: { "md-iconset": "fa fa-exclamation-circle" }
                    }),
                    _vm._v(" No items to show")
                  ],
                  1
                )
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82968a6c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82968a6c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/serie/InfoSeriesDialog.vue
// module id = 877
// module chunks = 0